import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, List, ListItem, ListItemIcon, ListItemText,
  Chip,
} from '@mui/material';
import { FiberManualRecord as BulletIcon } from '@mui/icons-material';
import { releasesAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

const WhatsNewModal = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [release, setRelease] = useState(null);

  useEffect(() => {
    if (!user) return;

    const checkForNewRelease = async () => {
      try {
        const res = await releasesAPI.getLatest();
        const latest = res.data.release;
        if (!latest) return;

        if (user.last_seen_version !== latest.version) {
          setRelease(latest);
          setOpen(true);
        }
      } catch (err) {
        // Silently ignore — non-critical
      }
    };

    checkForNewRelease();
  }, [user]);

  const handleClose = async () => {
    setOpen(false);
    if (release) {
      try {
        await releasesAPI.markSeen(release.version);
      } catch (err) {
        // Silently ignore
      }
    }
  };

  if (!release) return null;

  const items = Array.isArray(release.items) ? release.items : [];

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Typography variant="h6" fontWeight={600}>What's New</Typography>
          <Chip
            label={`v${release.version}`}
            size="small"
            color="primary"
            variant="outlined"
            sx={{ fontFamily: 'monospace', fontWeight: 600 }}
          />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" fontWeight={500} color="text.secondary" mb={1.5}>
          {release.title}
        </Typography>
        <List dense disablePadding>
          {items.map((item, index) => (
            <ListItem key={index} disablePadding sx={{ py: 0.5, alignItems: 'flex-start' }}>
              <ListItemIcon sx={{ minWidth: 24, mt: 1 }}>
                <BulletIcon sx={{ fontSize: 8, color: 'primary.main' }} />
              </ListItemIcon>
              <ListItemText
                primary={item}
                primaryTypographyProps={{ variant: 'body2', lineHeight: 1.6 }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={handleClose}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsNewModal;
